import AppointmentResponsibleNotification from "./AppointmentResponsibleNotification.vue";
import AppointmentEmployeeNotification from "./AppointmentEmployeeNotification.vue";

export { AppointmentResponsibleNotification, AppointmentEmployeeNotification };
